// extracted by mini-css-extract-plugin
export default {"overlay":"custom-popup_overlay__8GuEu","popup":"custom-popup_popup__UOhEz","close":"custom-popup_close__ZRPaz","content":"custom-popup_content__gsu7h"};